import { PokerType } from "./types/PokerType";

export function parsePokerType(param: string) {
  const maybeType = Number.parseInt(param);

  return isNaN(maybeType) ? PokerType.UNKNOWN : (maybeType as PokerType);
}
